import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import {
  UserPatrolData,
  PatrolSession,
  PatrolViolation,
} from 'src/app/state-management/states/guard-patrol.state';

@Injectable({
  providedIn: 'root',
})
export class PatrollingService {
  private apiUrl = `${environment.apiUrl?.replace(/\/+$/, '')}/patrolling`;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('AccessToken');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  // Start patrolling
  startPatrolling(
    geofenceId: string,
    startLatitude?: number,
    startLongitude?: number
  ): Observable<any> {
    const request = {
      geofenceId,
      startLatitude,
      startLongitude,
    };

    return this.http.post(`${this.apiUrl}/start`, request, {
      headers: this.getHeaders(),
    });
  }

  // End patrolling
  endPatrolling(
    sessionId: string,
    endLatitude?: number,
    endLongitude?: number,
    monitoringData?: any
  ): Observable<any> {
    const request = {
      endLatitude,
      endLongitude,
      monitoringData,
    };

    return this.http.post(`${this.apiUrl}/${sessionId}/end`, request, {
      headers: this.getHeaders(),
    });
  }

  // Get user patrol data
  getUserPatrolData(): Observable<UserPatrolData> {
    return this.http.get<UserPatrolData>(`${this.apiUrl}/user/data`, {
      headers: this.getHeaders(),
    });
  }

  // Get patrol sessions
  getPatrolSessions(): Observable<PatrolSession[]> {
    return this.http.get<PatrolSession[]>(`${this.apiUrl}/sessions`, {
      headers: this.getHeaders(),
    });
  }
  // Get active patrol sessions
  getActivePatrolSessions(): Observable<PatrolSession[]> {
    return this.http.get<PatrolSession[]>(`${this.apiUrl}/active`, {
      headers: this.getHeaders(),
    });
  }

  // Get patrol session by ID
  getPatrolSessionById(sessionId: string): Observable<PatrolSession> {
    return this.http.get<PatrolSession>(
      `${this.apiUrl}/sessions/${sessionId}`,
      {
        headers: this.getHeaders(),
      }
    );
  }

  // Get user patrol sessions
  getUserPatrolSessions(): Observable<PatrolSession[]> {
    return this.http.get<PatrolSession[]>(`${this.apiUrl}/user/sessions`, {
      headers: this.getHeaders(),
    });
  }

  // Get patrol violations
  getPatrolViolations(): Observable<PatrolViolation[]> {
    return this.http.get<PatrolViolation[]>(`${this.apiUrl}/violations`, {
      headers: this.getHeaders(),
    });
  }

  // Record patrol violation
  recordViolation(
    sessionId: string,
    geofenceId: string,
    userId: string,
    userName: string,
    violationType: string,
    latitude?: number,
    longitude?: number,
    distanceOutside?: number,
    userRole?: string
  ): Observable<any> {
    const request = {
      sessionId,
      geofenceId,
      userId,
      userName,
      violationType,
      latitude,
      longitude,
      distanceOutside,
      userRole,
    };

    return this.http.post(`${this.apiUrl}/violations`, request, {
      headers: this.getHeaders(),
    });
  }
}
